import {isNullOrUndefined} from "../../../services/Validator";
import {renderKnowledgeType} from "../../../controllers/SystemQuestionKnowledgeController";

export default function LevelAKnowledgeSticker({knowledgeType, knowledgeDefinition, isBrevetDisplay}) {
    // Used in LevelAMetaData to display whether LevelA is for
    // brevet

    // PROPERTIES
    const knowledgeTypeObject = renderKnowledgeType(knowledgeType, 0);

    // BUILD
    if (isNullOrUndefined(knowledgeType) || isNullOrUndefined(knowledgeDefinition))
        return null
    return (
        <div className={`ml-[16px] ${isBrevetDisplay ? "bg-greenStar/30 text-greenStar" : "bg-timerBlue/30 text-badgeBlue"} font-medium flex justify-center items-center space-x-[4px] rounded-full px-[12px] py-[2px]`}>
            <i className="-ml-[2px] material-icons text-[14px]">
                {knowledgeTypeObject.icon}
            </i>
            <span className={"text-[14px] font-medium"}>
                {knowledgeTypeObject.title}
            </span>
        </div>
    );
}